import { Box } from '@mui/material';

import TabsPanel from '../../../components/TabsPanel';
import { deductionRecoveryTab, deductionsAccountTabs } from '../../../constants/tabRoutes';
import { useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { getDeductionRecord } from '../../../api/paymentsApi/deductionsApi';
import moment from 'moment';

const DeductionAccountView = () => {
  const { deductionId } = useParams();
  const [entityRecordData, setEntityRecordData] = useState<{ [key: string]: unknown }>();

  useEffect(() => {
    getDeductionRecord(deductionId as string).then((res) => {
      if (res.data) {
        const hasDefendant = res.data.defendant !== null && Boolean(res.data.defendant.name.length);
        // const vendorPaymentMethod = res.data.vendor?.defaultPaymentMethod || '';
        // Map only Advance -> Expense Reimbursement (form schema value); keep SERVICE_PROVIDER as-is
        const type = res.data.type === 'Advance' ? 'Expense Reimbursement' : res.data.type;
        const vendor = res.data.vendor ? {
          id: res.data.vendor.id,
          label: res.data.vendor.name,
          defaultPaymentMethod: (res.data.paymentMethod && res.data.paymentMethod !== '-'
            ? res.data.paymentMethod
            : null),
        } : { id: '', label: '' };

        setEntityRecordData({
          referenceId: res.data.case.referenceId,
          id: res.data.id,
          caseReferenceId: res.data.case.id,
          caseSystemName: res.data.case.name,
          isAssigned: hasDefendant,
          amount: res.data.amount,
          type: type,
          status: res.data.mappedDeductionStatus,
          defendant: hasDefendant
            ? {
              id: res.data.defendant.id,
              label: res.data.defendant.name,
            }
            : {
              id: '',
              label: '',
            },
          disposition: res.data.disposition,
          vendorAccount: vendor,
          description: res.data.description,
          memo: res.data.memo,
          docFileName: res.data.fileName,
          docPath: res.data.docPath,
          paymentMethod: res.data.paymentMethod && res.data.paymentMethod !== '-'
            ? res.data.paymentMethod
            : null,
          vendorPaymentAccountId:
            res.data.vendorPaymentAccountId ?? res.data.paymentAccountId ?? null,
          vendorPaymentAccountName:
            res.data.vendorPaymentAccountName ?? res.data.paymentAccountName ?? null,
          preSettlementAmount: res.data.preSettlementAmount,
          entryDate: res.data.entryDate ? moment(res.data.entryDate) : undefined,
          externalPaymentReference: res.data.externalPaymentReference,
          // externalPaymentMemo: res.data.externalPaymentMemo,
          externalPaymentDate: res.data.externalPaymentDate ? moment(res.data.externalPaymentDate) : undefined,
          remittanceLines: res.data.remittanceLines ?? null,
          paidAt: res.data.paidAt ?? null,
          canUpdate: res.data.canUpdate
        });
      }
    });
  }, [deductionId]);

  // Recovery tab is shown after Timeline, only for paid Lien and Service Provider deductions
  const showRecoveryTab =
    entityRecordData?.status === 'Paid' &&
    (entityRecordData?.type === 'Lien' || entityRecordData?.type === 'SERVICE_PROVIDER');

  const tabsList = useMemo(
    () => (showRecoveryTab ? [...deductionsAccountTabs, deductionRecoveryTab] : deductionsAccountTabs),
    [showRecoveryTab],
  );

  return (
    <>
      <Box display='flex' width='100%'>
        <TabsPanel
          tabsList={tabsList}
          locationSlicePosition={4}
          contextData={entityRecordData}
        />
      </Box>
    </>
  );
};

export default DeductionAccountView;
